import React from 'react';
import ContentLoader from 'react-content-loader';

const GroupLoading = () => (
  <ContentLoader
    height={350}
    width={500}
    speed={1}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="30" y="33" rx="0" ry="0" width="120" height="120" />
    <rect x="45" y="165" rx="0" ry="0" width="90" height="12" />
    <rect x="188" y="31" rx="0" ry="0" width="120" height="120" />
    <rect x="203" y="164" rx="0" ry="0" width="90" height="12" />
    <rect x="349" y="27" rx="0" ry="0" width="120" height="120" />
    <rect x="364" y="160" rx="0" ry="0" width="90" height="12" />
    <rect x="30" y="200" rx="0" ry="0" width="120" height="120" />
    <rect x="45" y="332" rx="0" ry="0" width="90" height="12" />
    <rect x="188" y="198" rx="0" ry="0" width="120" height="120" />
    <rect x="203" y="331" rx="0" ry="0" width="90" height="12" />
    <rect x="349" y="194" rx="0" ry="0" width="120" height="120" />
    <rect x="364" y="327" rx="0" ry="0" width="90" height="12" />
  </ContentLoader>
);

export default GroupLoading;
